import { AnalyticsEventLocation } from 'services/analytics/entities';
import { Song } from 'services/store/songs/types';
import { useAddToLibrary, useRemoveFromLibrary } from 'services/hooks';
import { SongActionsContainer } from './styled';
import { SongActionButtonsRow } from './components/SongActionButtonsRow';

interface DesktopSongActionButtonsProps {
  song: Song;
  location: AnalyticsEventLocation;
}

const DesktopSongActionButtons = ({
  song,
  location,
}: DesktopSongActionButtonsProps) => {
  const { removeSongFromLibrary } = useRemoveFromLibrary({
    songId: song.id,
    location,
  });
  const { addSongToLibrary } = useAddToLibrary({ songId: song.id, location });

  return (
    <SongActionsContainer>
      <SongActionButtonsRow
        song={song}
        location={location}
        removeFromLibrary={removeSongFromLibrary}
        addToLibrary={addSongToLibrary}
      />
    </SongActionsContainer>
  );
};

export default DesktopSongActionButtons;
